export default __webpack_public_path__ + "static/media/portfolioOverview_screenshot.ee431c93.png";